import React, { useState, useEffect, useRef } from 'react';
import Crud_Catalogos from '../../herramientas/Crud_Catalogos';

function AudioPlayer({ uniqueid, funcionalidades }) {
  const [audioUrl, setAudioUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const audioRef = useRef(null);

  // Función crud corregida y movida fuera del useEffect
  const crud = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    return Crud_Catalogos(catalogo, "movimientos", metodo, id, obj, "", stateVar, hiddenModl, [])
      .then((returnVal) => {
        switch (metodo) {
          case "get":
            if (stateVar === "obtener_audio") {
              return returnVal;
            }
            break;
          default:
            break;
        }
        return returnVal;
      })
      .catch(err => {
        console.error('Error en crud:', err);
        throw err;
      });
  };

  useEffect(() => {
    const loadAudio = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('🔄 Cargando audio para uniqueid:', uniqueid);
        
        const response = await crud(
          "get", 
          [], 
          "", 
          `softphone_v2/obtener_audio?provedor=2&id=${uniqueid}`, 
          "obtener_audio"
        );
                
        if (response) {
          // Método 1: Si la respuesta es ArrayBuffer directamente
          if (response instanceof ArrayBuffer) {
            console.log('✅ ArrayBuffer detectado, tamaño:', response.byteLength);
            const blob = new Blob([response], { type: 'audio/wav' });
            const url = URL.createObjectURL(blob);
            setAudioUrl(url);
            return;
          }
          
          // Método 2: Si la respuesta tiene una propiedad data con ArrayBuffer
          if (response.data && response.data instanceof ArrayBuffer) {
            console.log('✅ ArrayBuffer en data detectado, tamaño:', response.data.byteLength);
            const blob = new Blob([response.data], { type: 'audio/wav' });
            const url = URL.createObjectURL(blob);
            setAudioUrl(url);
            return;
          }
          
          // Método 3: Si la respuesta es Uint8Array o similar
          if (response instanceof Uint8Array || (response.buffer && response.buffer instanceof ArrayBuffer)) {
            console.log('✅ Uint8Array detectado, tamaño:', response.length || response.byteLength);
            const blob = new Blob([response], { type: 'audio/wav' });
            const url = URL.createObjectURL(blob);
            setAudioUrl(url);
            return;
          }
          
          // Método 4: Si es un string base64
          if (typeof response.data === 'string' && response.startsWith('data:audio')) {
            console.log('✅ Base64 detectado');
            setAudioUrl(response);
            return;
          }
          
          // Método 5: Si es un string con datos binarios directos
          if (typeof response === 'string' || (response.data && typeof response.data === 'string')) {
            console.log('✅ String de datos detectado');
            const audioData = response.data || response;
            
            // Opción A: Intentar como base64 primero
            if (audioData.match(/^[A-Za-z0-9+/]*={0,2}$/)) {
              try {
                console.log('🔄 Intentando decodificar como base64...');
                const binaryString = atob(audioData);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                  bytes[i] = binaryString.charCodeAt(i);
                }
                const blob = new Blob([bytes], { type: 'audio/wav' });
                const url = URL.createObjectURL(blob);
                setAudioUrl(url);
                return;
              } catch (base64Error) {
                console.log('❌ No es base64 válido:', base64Error);
              }
            }
            
            // Opción B: Tratar como string binario directo (ISO-8859-1)
            try {
              console.log('🔄 Tratando como string binario directo...');
              const bytes = new Uint8Array(audioData.length);
              for (let i = 0; i < audioData.length; i++) {
                bytes[i] = audioData.charCodeAt(i) & 0xFF; // Máscara para mantener solo 8 bits
              }
              
              console.log('📊 Primeros bytes:', Array.from(bytes.slice(0, 20)).map(b => b.toString(16)).join(' '));
              
              const blob = new Blob([bytes], { type: 'audio/wav' });
              const url = URL.createObjectURL(blob);
              setAudioUrl(url);
              return;
            } catch (binaryError) {
              console.log('❌ Error tratando como binario:', binaryError);
            }
          }
          
          // Método 6: URL directa del endpoint
          console.log('🔗 Intentando URL directa del endpoint');
          const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
          const directUrl = `${baseUrl}/softphone_v2/obtener_audio?provedor=2&id=${uniqueid}`;
          setAudioUrl(directUrl);
          
        } else {
          setError('No hay datos de audio disponibles');
        }
        
      } catch (err) {
        console.error('❌ Error cargando audio:', err);
        setError('Error al cargar audio');
      } finally {
        setLoading(false);
      }
    };

    // Solo cargar si tiene permisos y uniqueid
    const tienePermisoAudio = funcionalidades?.some(f => f.nombre === "audio");
    
    if (uniqueid && tienePermisoAudio) {
      loadAudio();
    } else {
      setLoading(false);
      if (!tienePermisoAudio) {
        console.log('❌ Sin permisos de audio');
      }
      if (!uniqueid) {
        console.log('❌ Sin uniqueid');
      }
    }

    // Cleanup para liberar URLs blob
    return () => {
      if (audioUrl && audioUrl.startsWith('blob:')) {
        URL.revokeObjectURL(audioUrl);
      }
    };
  }, [uniqueid, funcionalidades]);

  // Manejar errores de carga de audio
  const handleAudioError = (e) => {
    console.error('❌ Error reproduciendo audio:', e);
    setError('Error de reproducción');
  };

  const handleAudioLoad = () => {
    console.log('✅ Audio cargado correctamente');
  };

  // Si no tiene permisos de audio
  const tienePermisoAudio = funcionalidades?.some(f => f.nombre === "audio");
  if (!tienePermisoAudio) {
    return null;
  }

  if (loading) {
    return (
      <div style={{ fontSize: '12px', color: '#666', textAlign: 'center', padding: '8px' }}>
        🔄 Cargando audio...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ fontSize: '12px', color: '#e74c3c', textAlign: 'center', padding: '8px' }}>
        ⚠️ {error}
      </div>
    );
  }

  if (!audioUrl) {
    return (
      <div style={{ fontSize: '12px', color: '#95a5a6', textAlign: 'center', padding: '8px' }}>
        🔇 Sin audio
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <audio 
        ref={audioRef}
        controls 
        key={uniqueid} // Forzar re-render cuando cambie uniqueid
        style={{ width: '400px', height: '32px' }}
        preload="none"
        onError={handleAudioError}
        onLoadedData={handleAudioLoad}
        onLoadStart={() => console.log('🔄 Iniciando carga de audio...')}
      >
        <source src={audioUrl} type="audio/wav" />
        Tu navegador no soporta audio HTML5.
      </audio>
    </div>
  );
}

export default AudioPlayer;